import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { initializeI18n } from '../i18n/i18n';
import axios from 'axios';
import { getApiBaseUrl } from '../lib/api-base-url';

const API_URL = getApiBaseUrl();

interface LanguageContextType {
  language: string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<string>('en');
  const { user } = useAuth();

  useEffect(() => {
    const fetchTenantLanguage = async () => {
      if (user?.tenantId) {
        try {
          const response = await axios.get(`${API_URL}/tenants/${user.tenantId}`);
          const tenantLanguage = response.data.language || 'en';
          setLanguage(tenantLanguage);
          initializeI18n(tenantLanguage);
        } catch (error) {
          console.error('Error fetching tenant language:', error);
          initializeI18n('en');
        }
      }
    };

    fetchTenantLanguage();
  }, [user?.tenantId]);

  return (
    <LanguageContext.Provider value={{ language }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
